type UfNamed = {
  value: string;
  id: string;
}[]

export const ufsNamed: UfNamed = [
  { value: 'Acre', id: 'AC' },
  { value: 'Alagoas', id: 'AL' },
  { value: 'Amapá', id: 'AP' },
  { value: 'Amazonas', id: 'AM' },
  { value: 'Bahia', id: 'BA' },
  { value: 'Ceará', id: 'CE' },
  { value: 'Distrito Federal', id: 'DF' },
  { value: 'Espírito Santo', id: 'ES' },
  { value: 'Goiás', id: 'GO' },
  { value: 'Maranhão', id: 'MA' },
  { value: 'Mato Grosso', id: 'MT' },
  { value: 'Mato Grosso do Sul', id: 'MS' },
  { value: 'Minas Gerais', id: 'MG' },
  { value: 'Pará', id: 'PA' },
  { value: 'Paraíba', id: 'PB' },
  { value: 'Paraná', id: 'PR' },
  { value: 'Pernambuco', id: 'PE' },
  { value: 'Piauí', id: 'PI' },
  { value: 'Rio de Janeiro', id: 'RJ' },
  { value: 'Rio Grande do Norte', id: 'RN' },
  { value: 'Rio Grande do Sul', id: 'RS' },
  { value: 'Rondônia', id: 'RO' },
  { value: 'Roraima', id: 'RR' },
  { value: 'Santa Catarina', id: 'SC' },
  { value: 'São Paulo', id: 'SP' },
  { value: 'Sergipe', id: 'SE' },
  { value: 'Tocantins', id: 'TO' },
];


export function getEnumKeyByValue<T extends { [index: string]: string | number }>(enumObj: T, value: string | number): string | undefined {
  const keys = Object.keys(enumObj).filter(k => enumObj[k as any] === value);
  return keys.length > 0 ? keys[0] : undefined;
}